var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "list-products" }, [
        _c(
          "div",
          { staticClass: "card-body" },
          _vm._l(_vm.filteredProducts, function (product) {
            return _c(
              "div",
              {
                key: product.id,
                staticClass: "row show-grid product",
                class:
                  "group-" + product.name.replace(/\s+/g, "-").toLowerCase(),
              },
              [
                _c("div", { staticClass: "col-md-12 header-product-name" }, [
                  _c("div", { staticClass: "header-product-name-trigger " }, [
                    _c("h2", { staticClass: "product-title-wrapper" }, [
                      _c("img", {
                        attrs: {
                          src:
                            "images/program-icons/" +
                            product.title.replace(" ", "-") +
                            ".svg",
                          alt: "icon",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "product-head" }, [
                        _vm._v(_vm._s(product.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "product-type" }, [
                        _vm._v(_vm._s(product.description)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tab-content" }, [
                        _c(
                          "div",
                          {
                            class:
                              "tab-pane show active panel_" +
                              product.name.replace(/\s+/g, "-").toLowerCase() +
                              "_lease",
                            attrs: {
                              id:
                                "panel_" +
                                product.name
                                  .replace(/\s+/g, "-")
                                  .toLowerCase() +
                                "_lease",
                              role: "tabpanel",
                              "aria-labelledby": "second-tab",
                            },
                          },
                          [
                            _c("div", { staticClass: "nav-info" }, [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(product.description) +
                                  "\n                                    "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "header-name-block" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-8 col-md header-name header-name__first",
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.getTranslation(
                                      "product-list-vue",
                                      "programs_and_packages"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-1 header-name col-price",
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.getTranslation("front", "price")) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-2 header-name col-spinner",
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.getTranslation(
                                      "product-list-vue",
                                      "local_licences"
                                    )
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          product.purchase_options.has_network
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-4 col-md-2 header-name col-spinner",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(
                                          _vm.getTranslation(
                                            "product-list-vue",
                                            "network_licences"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-4 col-md-2 header-name col-price col-price--total",
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.getTranslation("front", "total")) +
                                  "\n                                "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tab-content" }, [
                    product.purchase_options.has_lease
                      ? _c(
                          "div",
                          {
                            staticClass: "tab-pane show active",
                            class:
                              "v-pills-" +
                              product.name.replace(/\s+/g, "-").toLowerCase(),
                            attrs: {
                              id:
                                "v-pills-" +
                                product.name
                                  .replace(/\s+/g, "-")
                                  .toLowerCase() +
                                "-lease",
                              role: "tabpanel",
                              "aria-labelledby":
                                "v-pills-" +
                                product.name
                                  .replace(/\s+/g, "-")
                                  .toLowerCase() +
                                "-lease-tab",
                            },
                          },
                          [
                            _c("div", { staticClass: "product-subtitle" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collapsible-panel ",
                                class:
                                  product.name
                                    .replace(/\s+/g, "-")
                                    .toLowerCase() + "lease-perpetual-collapse",
                                attrs: {
                                  id:
                                    "collapse_" +
                                    product.name
                                      .replace(/\s+/g, "-")
                                      .toLowerCase() +
                                    "_lease",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "header-name-block header-name-block__sticky",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "row" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-8 col-md header-name header-name__first",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.getTranslation(
                                                    "product-list-vue",
                                                    "programs_and_packages"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "col-4 col-md-1 header-name col-price text-center",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getTranslation(
                                                "product-list-vue",
                                                "price_for_lease"
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 col-md-2 header-name col-spinner",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.getTranslation(
                                                    "product-list-vue",
                                                    "cloud_licences"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        product.purchase_options.has_network
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-4 col-md-2 header-name col-spinner",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.getTranslation(
                                                          "product-list-vue",
                                                          "network_licences"
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTruss4Product(product.id)
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-4 col-md-2 header-name col-spinner text-center",
                                                  staticStyle: {
                                                    "align-items": "center",
                                                    "justify-content": "center",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.getTranslation(
                                                          "product-list-vue",
                                                          "period"
                                                        )
                                                      ) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.$store.state.cart.loggedInUser
                                          ? _c("div", {
                                              staticClass:
                                                "col-4 col-md-1 header-name col-price col-price--total",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getTranslation(
                                                    "product-list-vue",
                                                    "existing_licenses"
                                                  )
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-4 col-md-2 header-name col-price col-price--total",
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.getTranslation(
                                                    "front",
                                                    "total"
                                                  )
                                                ) +
                                                "\n                                        "
                                            ),
                                          ]
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("program-list", {
                                  attrs: { product: product, prefix: "lease" },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _c("label", { attrs: { for: "order_note" } }, [
          _vm._v(_vm._s(_vm.getTranslation("front", "NOTE"))),
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userNote,
              expression: "userNote",
            },
          ],
          staticClass: "form-control",
          attrs: { id: "order_note", rows: "5", cols: "40" },
          domProps: { value: _vm.userNote },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.userNote = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-summary__footer mt-4" }, [
        _c(
          "a",
          {
            staticClass:
              "btn btn-primary submitbtn btn-order ml-auto submitCart",
            attrs: { id: "continueNextStep" },
            on: {
              click: function ($event) {
                return _vm.goToKeySetup()
              },
            },
          },
          [
            _c("span", { staticClass: "continue" }, [
              _vm._v(_vm._s(_vm.getTranslation("front", "continue"))),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "continue-spinner align-items-center d-none" },
              [
                _c("b-spinner", {
                  attrs: { small: "", variant: "light", label: "Loading..." },
                }),
                _vm._v(
                  " " +
                    _vm._s(_vm.getTranslation("front", "loading")) +
                    "\n            "
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "bv-modal-warning", centered: "", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-title__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.getTranslation("key-setup-vue", "warning"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "d-block text-center" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.getTranslation("home", "empty_cart_error"))),
            ]),
            _vm._v(" "),
            _c("br"),
            _c("br"),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getTranslation("front", "close")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "bv-modal-upgrade", centered: "", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c("div", { staticClass: "modal-title__icon" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          role: "img",
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 512 512",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-block", staticStyle: { padding: "0 10px" } },
            [
              !_vm.loggedInUser
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.getTranslation(
                          "product-list-vue",
                          "message_new_customer_modal_upgrade_line_1"
                        )
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.loggedInUser
                ? _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.getTranslation(
                          "product-list-vue",
                          _vm.loggedInUpgradeMessageLine1
                        )
                      ),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", {
                staticClass: "bv-modal-lineTwo",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.getTranslation(
                      "product-list-vue",
                      "message_upgrade_to_" + _vm.upgradeUserLevel
                    )
                  ),
                },
              }),
              _vm._v(" "),
              _c("br"),
              _c("br"),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.closeUpgradeModal()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getTranslation("front", "close")))]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "mt-3 mx-auto",
                  on: {
                    click: function ($event) {
                      return _vm.continueNextStep()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.getTranslation(
                        "front",
                        "modal_upgrade_continue_button"
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }